export const Environment = {
  // url: process.env.REACT_APP_API_BASE_URL || "http://172.22.20.41/api/" ,
    url:  "https://trackerapp.winfertility.com/api/", // Fallback to dev 
   //url:  "https://sandboxapp.winfertility.com/api/",
  };
